<template>
  <section class="bg-[--white2] flex flex-col w-full items-center py-[45px] lg:py-[72px]">
    <div class="flex flex-col gap-[31px] w-full px-[32px] xs:px-[51px] xl:w-[1280px] items-center lg:flex-row-reverse lg:justify-center lg:gap-[37px] xl:gap-[71px]">

      <div class="flex flex-col gap-[41px] w-auto items-center lg:items-start">
        <div class="section-header-container !w-auto lg:items-start">
          <h4 class="section-header-1 ">Crédito Vip</h4>
          <h3 class="section-header-2 lg:text-left">
            Como obter <br />
            meu empréstimo?
          </h3>
        </div>

        <ul class="flex flex-col gap-[17px] w-full xs:w-[378px] xl:w-[400px]">
          <li v-for="(text, index) in texts" :key="index" class="flex gap-[35px] items-center">
            <span class="font-bold text-[35px] yellow w-[51px]" v-text="`0${index + 1}`"></span>
            <p class="text-[20px]" v-text="text"></p>
          </li>
        </ul>
        <LinkButton customClass="!py-[12.5px] !px-[25px] !w-full !text-[20px] lg:!w-[288px]" :url="whatsappUrl"
          label="Antecipar agora" />
      </div>

      <div class="flex w-[242px] lg:min-w-[292px] lg:max-w-[342px] xl:w-[342px]">
        <img class="object-cover w-full" src="/img/celular-fgts.webp" alt="Banner" />
      </div>
    </div>
  </section>
</template>
<script>
import LinkButton from "../components/LinkButton.vue";
import { useWhatsappUrl } from "@/composables/useWhatsappUrl";

export default {
  name: "SectionHistory",
  components: {
    LinkButton,
  },
    setup() {
    const { whatsappUrl } = useWhatsappUrl('Olá, gostaria de simular minha antecipação do FGTS.')
    return { whatsappUrl }
  },
  data() {
    return {
      texts: [
        "Entre em contato com a Vip.",
        "Faça uma simulação gratuita.",
        "Leia o contrato e assine.",
        "Receba o valor dentro de algumas horas.",
      ],
    };
  },
};
</script>
